import React, { useState } from 'react';
import { any } from 'prop-types';
import styled, { css } from 'styled-components';
import { Button, FlexContainer } from '../../src/components/common';

const Body = styled.div`
    width: 21cm;
    ${({ isPrinting }) => (isPrinting === false) && css`
        height: 100vh;
    `}
    padding: 41px;
    margin: 0 auto;
    color: #333333;
    font-size: 9px;
    background-color: #FFFFFF;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    color-adjust: exact;
    ${({ isPrinting }) => (isPrinting === true) && css`
        width: 6.5cm;
        padding: 0;
        margin-top: 2px;
    `}
    @page {
        margin: 0;
        size: 6.5cm 4cm;
    }
`;

const LabelQrWrapper = ({ children }) => {
    const [isPrinting, setPrinting] = useState(false);

    const print = () => {
        setPrinting(true);
        setTimeout(() => {
            window.print();
            setPrinting(false);
        }, 20);
    };

    return (
        <FlexContainer direction='column' style={isPrinting ? { minHeight: '100vh' } : { height: '100vh', width: '100vw', justifyContent: 'flex-start' }}>
            {!isPrinting && <Button onClick={() => print()}>Imprimir</Button>}
            <Body isPrinting={isPrinting}>
                {children({ isPrinting })}
            </Body>
        </FlexContainer>
    );
};

LabelQrWrapper.propTypes = {
    children: any
};

export default LabelQrWrapper;
